 <h2>{{'help.contact.shortLabel' | translate}}</h2>
<mat-list dense>
    <mat-list-item>
        <mat-icon class="list-icon" matListIcon>phone</mat-icon>
        <p matLine> {{ support.phone }} </p>
    </mat-list-item>
    <mat-list-item>
        <mat-icon class="list-icon" matListIcon>email</mat-icon>
        <p matLine><a [href]="'mailto:'+support.email">{{ support.email }}</a></p>
    </mat-list-item>
</mat-list>

<h2 *ngIf="isAuth">{{'auth.newsletter.title.fullLabel' | translate}}</h2>
<p *ngIf="isAuth">
    <mat-checkbox [checked]="isSubscribedNewsletter" [disabled]="!canSubscribeNewsletter" (change)="isSubscribedNewsletterChanged($event)">
        {{'auth.newsletter.subscription.summary' | translate}}
    </mat-checkbox>
</p>

<h2>{{'help.businessHours.shortLabel' | translate}}</h2>
<div class="detail" [innerHTML]="'help.businessHours.detail' | translate"></div>
